import {Component, effect, inject, signal} from '@angular/core';
import {FarmStore} from 'src/app/domain/assets/farm/farm.store';
import {areaWithUnit} from 'src/app/domain/util/units/units';


@Component({
  selector: 'app-farm-geometry',
  imports: [],
  templateUrl: './farm-geometry.component.html',
  styleUrl: './farm-geometry.component.css'
})
export class FarmGeometryComponent {

  area = signal<string | undefined>(undefined);

  farmStore = inject(FarmStore);

  constructor() {
    effect(() => {
      const area = this.farmStore.area();
      if (!area) return;

      const countryCode = this.farmStore.farm()?.address.countryCode;
      this.area.set(areaWithUnit(area, countryCode));
    });
  }
}
